import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function More({ onLogout }) {
  const navigate = useNavigate();

  const items = [
    { label: 'Import', path: '/import' },
    { label: 'Export', path: '/export' },
    { label: 'Manage Tags', path: '/tags' },
    { label: 'Find Duplicates', path: '/duplicates' },
    { label: 'Archive', path: '/archive' },
    { label: 'Trash', path: '/trash' },
  ];

  const btnStyle = {
    display: 'block', width: '100%', padding: '0.75rem 1.25rem',
    background: 'var(--surface)', border: '0.5px solid var(--border)',
    borderRadius: 'var(--radius)', textAlign: 'left', fontSize: '1rem',
    color: 'var(--text)', cursor: 'pointer', fontFamily: 'sans-serif',
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <div className="page-header">
        <h1>More</h1>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {items.map(item => (
          <button
            key={item.path}
            onClick={() => { if (window.__gleanNavGuard) { window.__gleanNavGuard(item.path); } else { navigate(item.path); } }}
            style={btnStyle}
          >
            {item.label}
          </button>
        ))}
        <button onClick={onLogout} style={{ ...btnStyle, color: 'var(--no)', background: 'none', border: '0.5px solid var(--border)' }}>
          Log Out
        </button>
      </div>
    </div>
  );
}
